import { render, staticRenderFns } from "./ModelMeta.vue?vue&type=template&id=39071123&scoped=true"
import script from "./ModelMeta.vue?vue&type=script&lang=js"
export * from "./ModelMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39071123",
  null
  
)

export default component.exports